import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import { userLogin, nonMemberCartMerge, getRecentViewList, demoLogin } from '../api'
import { AppBridge, secureSS } from '@/assets/js/common.js'
import TokenServices from '@/service/tokenService'
Vue.use(Vuex)

import variableStore from '@/store/modules/variableStore.js'

export const store = new Vuex.Store({
  modules: {
    variableStore: variableStore
  },

  state: {
    isDemo: true,
    webVersion: '1.2.13',
    userInfo: {},
    isLogin: false, // 로그인을 했는지 여부,
    snsLoginMethod: '',
    product: {},
    postCode: {address: '', detail: '', zonecode: '', initFlag: null},
    optionAddedPrice: null,
    finalPrice: null,
    payMethod: null,
    selectedOptions: [],
    selectedAddPrdts: [],
    isAuth: false,
    ordererInfo: {name: '', phone: '', email: ''},
    destInfo: {name: '', phone: ''},
    payPriceInfo: {prdtPrice: 0, discount: 0, deliveryPrice: 0, addDeliveryCost: 0, debitAmount: 0, prepaymentAmount: 0, addingPrepaymentAmount: 0, addingDebitAmount: 0},
    claimReviewId: null,
    declareModalShow: false,
    detailPrdtSysIds: {},
    selectedCoupons: [],
    couponAmountList:[],
    movieReviews: [],
    photoReviews: [],
    prdtReviews: [],
    multiReviews: [],
    withdraw: {},
    withdrawBank: null,
    latestAccInfo: {},
    groupChk: {id: null, flag: false},
    orderCodeForApp: '',
    totalPrice:{},
    sellingRequest: false,

    // nft
    aboutTab: 0,
    csFormOpen: false,
    privacyPopOpen: false
  },

  getters: {
    getVersion: state => state.webVersion,
    getId: state => state.userInfo.userId,
    getLogined: state => state.isLogin,
    getUser: state => state.userInfo,
    getIsAuth: state => state.isAuth,
    getProduct: state => state.product,
    getOptionAddedPrice: state => state.optionAddedPrice,
    getPayMethod: state => state.payMethod,
    getFinalPrice: state => state.finalPrice,
    getSelectedOptions: state => state.selectedOptions,
    getSelectedOptionsLength: state => state.selectedOptions.length,
    getOptionCnt: state => idx => state.selectedOptions[idx].count,
    getOptionPrice: state => idx => state.selectedOptions[idx].price,
    getSelectedAddPrdts: state => state.selectedAddPrdts,
    getSelectedAddPrdtsLength: state => state.selectedAddPrdts.length,
    getAddPrdtCnt: state => idx => state.selectedAddPrdts[idx].addingQty,
    getAddPrdtPrice: state => idx => state.selectedAddPrdts[idx].price,
    getPostCode: state => state.postCode,
    getPayPriceInfo: state => state.payPriceInfo,
    getOrdererInfo: state => state.ordererInfo,
    getDestInfo: state => state.destInfo,
    getSelectedCoupon: state => state.selectedCoupon,
    getMovieReviews: state => state.movieReviews,
    getPhotoReviews: state => state.photoReviews,
    getPrdtReviews: state => state.prdtReviews,
    getGroupChk: state => state.groupChk,
    getCouponDiscountAmount(state){
      return state.couponAmountList.reduce((acc,a)=>{
        return acc + a
      }, 0)
    }
  },

  mutations: {
    // 로그인 성공시
    async loginSuccess (state) {
      if (sessionStorage.getItem('accessToken')) {
        state.isLogin = true
        
        // 바텀네비게이션 최근본상품
        if (!window.TokenService) { window.TokenService = await new TokenServices() }

        AppBridge.send('tracking', JSON.stringify({value: 'login', type: 0}), true)

        const botStr = `?startIndex=0&rowCount=1`
        const botPrdtRes = await getRecentViewList(sessionStorage.getItem('accessToken'), botStr)
        console.log('최근본상품: ', botPrdtRes)
        if (botPrdtRes.data.jsonData.resultCode === '0001' && botPrdtRes.data.jsonData.views.length > 0) {
          const botPrdt = botPrdtRes.data.jsonData.views[0]
          secureSS.set('botNavPrdt', botPrdt)

          const botPrdtObj = {
            imgUrl: botPrdt.squareImageUrl || botPrdt.bigImageUrl
          }
          AppBridge.send('botNavPrdt', JSON.stringify(botPrdtObj), true)
        }
        
      } else {
        state.isLogin = false
      }
    },
    // 로그인 실패시
    loginError (state) {
      state.isLogin = false
    },
    logOut (state) {
      state.isDemo = true
      state.isLogin = false
      state.userInfo = {}
      state.snsLoginMethod = ''
      sessionStorage.clear()
    },
    addOption: (state, item) => state.selectedOptions.push(item),
    deleteOption: (state, idx) => state.selectedOptions.splice(idx, 1),
    deleteAllOption (state) { state.selectedOptions = [] },
    setOption (state, item) { state.selectedOptions = [...state.selectedOptions, item] },
    decreaseOptionCnt: (state, idx) => state.selectedOptions[idx].count--,
    increaseOptionCnt: (state, idx) => state.selectedOptions[idx].count++,
    setOptionCnt (state, [idx, num]) {
      state.selectedOptions[idx].count = num
    },
    addAddPrdt: (state, item) => state.selectedAddPrdts.push(item),
    deleteAddPrdt: (state, idx) => state.selectedAddPrdts.splice(idx, 1),
    deleteAllAddPrdts (state) { state.selectedAddPrdts = [] },
    decreaseAddPrdtCnt: (state, idx) => state.selectedAddPrdts[idx].addingQty--,
    increaseAddPrdtCnt: (state, idx) => state.selectedAddPrdts[idx].addingQty++,
    setAddPrdtCnt (state, [idx, num]) {
      state.selectedAddPrdts[idx].addingQty = num
    },
    updatePayPriceInfo (state, {name, price}) {
      state.payPriceInfo[name] = price
    },

    clearPayPriceInfo(state){
      state.payPriceInfo = {prdtPrice: 0, discount: 0, deliveryPrice: 0, addDeliveryCost: 0, debitAmount: 0, prepaymentAmount: 0, addingPrepaymentAmount: 0, addingDebitAmount: 0}
    },

    updateOrdererInfo (state, [name, value]) {
      state.ordererInfo[name] = value
    },
    updateDestInfo (state, [name, value]) {
      state.destInfo[name] = value
    },
    updateAddDeliveryCost (state, cost) {
      state.payPriceInfo.addDeliveryCost = cost
    },
    showDeclare (state, prdtReviewSysId) {
      state.declareModalShow = true
      if (prdtReviewSysId) {
        state.claimReviewId = prdtReviewSysId
      }
    },
    unShowDeclare (state) {
      state.declareModalShow = false
    },
    updatePostCode (state, {name, value}) {
      state.postCode[name] = value
    },
    newPostCode (state, postCode) {
      state.postCode = postCode
    },

    setMovieReviews (state, arr) {
      state.movieReviews = arr
    },
    setPhotoReviews (state, arr) {
      state.photoReviews = arr
    },
    setMultiReviews(state, arr){
      state.multiReviews = arr
    },
    setPrdtReviews (state, arr) {
      state.prdtReviews = arr
    },
    setGroupChk (state, obj) {
      state.groupChk.id = obj.id
      state.groupChk.flag = obj.flag
    },
    clearOrderInfo(state){
      state.payPriceInfo = {prdtPrice: 0, discount: 0, deliveryPrice: 0, addDeliveryCost: 0, debitAmount: 0, prepaymentAmount: 0, addingPrepaymentAmount: 0, addingDebitAmount: 0}
      state.selectedCoupon = {},
      state.postCode = {address: '', detail: '', zonecode: '', initFlag: null}
    },
    setSelectedCoupons(state, coupons){
      state.selectedCoupons = coupons
    },
    setCouponAmountList(state, amounts){
      state.couponAmountList = amounts
    },
    updateCouponAmountList(state, {idx, amount}){
      let ret = Object.assign([],state.couponAmountList)
      ret[idx] = amount
      state.couponAmountList = ret
    },
    setOrderCodeForApp(state, orderCode){
      state.orderCodeForApp = orderCode
    },
    setTotalPrice(state, obj){
      state.totalPrice[obj.idx] = {price : obj.val}
    },
    setSellingRequest (state, boolean) {
      state.sellingRequest = boolean
    },
    setIsDemo (state, boolean) {
      state.isDemo = boolean
    },

    // nft
    setAboutTab (state, payload) {
      state.aboutTab = payload
    },

    setCsFormOpen (state, payload) {
      state.csFormOpen = payload
    },

    setPrivacyPopOpen (state, payload) {
      state.privacyPopOpen = payload
    }
  },

  actions: {
    // 로그아웃
    logOut ({commit}) {
      commit('logOut')
      var varUA = navigator.userAgent.toLowerCase()
      if (varUA.indexOf('native') > -1 && varUA.indexOf('ios') > -1) {
        AppBridge.delete('saveUser')
      } else {
        localStorage.removeItem('saveUser')
      }
      sessionStorage.removeItem('sally')
      sessionStorage.setItem('setGroupChk', JSON.stringify({id: '0', flag: false}))
      window.location.replace('/demo')
    },
    // 로그인
    login ({dispatch, state, commit}, loginObj) {
      if (loginObj.id  !== '' && loginObj.password !== '') {
        userLogin(loginObj.id, loginObj.password, loginObj.isRsa)
        .then(async res => {
          if (res.data.jsonData.resultCode === '0001') {
            let accessToken = res.data.jsonData.accessToken
            let refreshToken = res.data.jsonData.refreshToken
            sessionStorage.setItem('accessToken', accessToken)
            sessionStorage.setItem('refreshToken', refreshToken)
            sessionStorage.setItem('setGroupChk', JSON.stringify({id: res.data.jsonData.groupIds || '0', flag: res.data.jsonData.groupIds ? true : false}))
            sessionStorage.setItem('nickName', res.data.jsonData.nickName)
            sessionStorage.setItem('userSysId', res.data.jsonData.authSysId)

            window.TokenService._setToken()

            if (loginObj.autoChk) {
              if (loginObj.isIos) {
                AppBridge.set('saveUser', JSON.stringify({ refreshToken: refreshToken }))
              } else {
                localStorage.setItem('saveUser', JSON.stringify({ refreshToken: refreshToken }))
              }
            }

            state.userInfo.userId = loginObj.id
            state.userInfo.password = loginObj.password
            state.isDemo = false

            commit('loginSuccess')

            // 로그인 처리 이후 라우팅
            try {
              if (loginObj.landingPage) {
                router.replace(loginObj.landingPage)
              } else {
                let lp = sessionStorage.getItem('landingPage')
                if (lp && (lp.indexOf('http') > -1 || lp.indexOf('https') > -1)) {
                  location.href = lp ? lp : location.origin
                } else {
                  router.replace(lp ? lp : '/demo')
                }
              }
            } catch (err) {
              console.log(err)
            }
          } else if (res.data.jsonData.resultCode === '1006') {
            alert('탈퇴했던 아이디 입니다. 탈퇴 후 일정 기간 이내에는 재가입 할 수 없습니다.')
          } else {
            alert('아이디나 패스워드가 다릅니다.')
            var varUA = navigator.userAgent.toLowerCase()
            if (varUA.indexOf('native') > -1 && varUA.indexOf('ios') > -1) {
              AppBridge.delete('saveUser')
            } else {
              localStorage.removeItem('saveUser')
            }
            return false
          }

        })
        .catch(function (error) {
          console.log('ERROR', error)
          alert('로그인에 실패했습니다.')
          router.replace('/demo')
        })
      } else {
        demoLogin()
          .then(async res => {
            if (res.data.jsonData.resultCode === '0001') {
              let accessToken = res.data.jsonData.accessToken
              let refreshToken = res.data.jsonData.refreshToken
              sessionStorage.setItem('accessToken', accessToken)
              sessionStorage.setItem('refreshToken', refreshToken)
              sessionStorage.setItem('setGroupChk', JSON.stringify({id: res.data.jsonData.groupIds || '0', flag: res.data.jsonData.groupIds ? true : false}))
              sessionStorage.setItem('nickName', '위즈몰 데모')
              sessionStorage.setItem('userSysId', res.data.jsonData.authSysId)

              state.isLogin = true

              window.TokenService._setToken()

              try {

                if (loginObj.landingPage) {
                  router.replace(loginObj.landingPage)
                } else {
                  let lp = sessionStorage.getItem('landingPage')
                  if (lp && (lp.indexOf('http') > -1 || lp.indexOf('https') > -1)) {
                    location.href = lp ? lp : location.origin
                  } else {
                    router.replace(lp ? lp : '/demo')
                  }
                }
              } catch (err) {
                console.log(err)
              }
            } else if (res.data.jsonData.resultCode === '1006') {
              alert('탈퇴했던 아이디 입니다. 탈퇴 후 일정 기간 이내에는 재가입 할 수 없습니다.')
            } else {
              alert('아이디나 패스워드가 다릅니다.')
              var varUA = navigator.userAgent.toLowerCase()
              if (varUA.indexOf('native') > -1 && varUA.indexOf('ios') > -1) {
                AppBridge.delete('saveUser')
              } else {
                localStorage.removeItem('saveUser')
              }
              return false
            }
          })
          .catch(function (error) {
            console.log('ERROR', error)
          })
      }
    },
    getUserInfo ({commit}) {
      return new Promise(async (resolve, reject) => {
        commit('loginSuccess')
        await nonMemberCartMerge()
        resolve()
      })
    },
    getUserInfoSns ({commit}) {
      return new Promise((resolve, reject) => {
        commit('loginSuccess')
        resolve()
      })
    },

    isDemo ({state}) {
      if (state.isDemo) {
        alert('데모버전에는 제한되는 기능 입니다.')
        return true
      } else {
        return false
      }
    },

    scrollTo ({}, payload) {
      const scr = document.querySelector('.appScr')
      if (payload.y !== undefined) { scr.scrollTop = payload.y }
      if (payload.x !== undefined) { scr.scrollLeft = payload.x }
    }
  }
})
